import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CalendarSnackbars } from '../types/calendar-snackbars.config';

@Injectable({
  providedIn: 'root',
})
export class ScheduleSnackbarsService {
  private snackbar = inject(MatSnackBar);

  public successClosedMonth(): void {
    this.snackbar.open(
      CalendarSnackbars.successClosedMonth.message,
      CalendarSnackbars.successClosedMonth.closeBtn,
      CalendarSnackbars.successClosedMonth.config
    );
  }

  public failExport(): void {
    this.snackbar.open(
      CalendarSnackbars.failExport.message,
      CalendarSnackbars.failExport.closeBtn,
      CalendarSnackbars.failExport.config
    );
  }

  public successChangeRequestStatus(): void {
    this.snackbar.open(
      CalendarSnackbars.successChangeRequestStatus.message,
      CalendarSnackbars.successChangeRequestStatus.closeBtn,
      CalendarSnackbars.successChangeRequestStatus.config
    );
  }

  public failChangeRequestStatus(): void {
    this.snackbar.open(
      CalendarSnackbars.failChangeRequestStatus.message,
      CalendarSnackbars.failChangeRequestStatus.closeBtn,
      CalendarSnackbars.failChangeRequestStatus.config
    );
  }

  public failRequestCollisionDates(): void {
    this.snackbar.open(
      CalendarSnackbars.failRequestCollisionDates.message,
      CalendarSnackbars.failRequestCollisionDates.closeBtn,
      CalendarSnackbars.failRequestCollisionDates.config
    );
  }

  public failCloseMonthNoFinalized(): void {
    this.snackbar.open(
      CalendarSnackbars.failCloseMonthNoFinalized.message,
      CalendarSnackbars.failCloseMonthNoFinalized.closeBtn,
      CalendarSnackbars.failCloseMonthNoFinalized.config
    );
  }

  public successOpenMonth(): void {
    this.snackbar.open(
      CalendarSnackbars.successOpenMonth.message,
      CalendarSnackbars.successOpenMonth.closeBtn,
      CalendarSnackbars.successOpenMonth.config
    );
  }

  public successClosedMonths(): void {
    this.snackbar.open(
      CalendarSnackbars.successClosedMonths.message,
      CalendarSnackbars.successClosedMonths.closeBtn,
      CalendarSnackbars.successClosedMonths.config
    );
  }

  public failCloseMonths(): void {
    this.snackbar.open(
      CalendarSnackbars.failCloseMonths.message,
      CalendarSnackbars.failCloseMonths.closeBtn,
      CalendarSnackbars.failCloseMonths.config
    );
  }
}
